import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { BORDER, COLOR_GREY_4 } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex()};
  width: calc(100% - 328px);
`;

export const StyledEmptyContainer = styled(Box)`
  ${flex({ ai: "center", jc: "center" })};
  height: 100vh;
  width: calc(100% - 328px);
`;

export const StyledTicketChatContainer = styled(Box)`
  ${flex({ fd: "column", jc: "space-between" })};
  width: calc(100% - 282px);
  height: calc(100vh - 72px - 60px - 48px);
  overflow: hidden;
  border-right: ${BORDER(1, COLOR_GREY_4)};
`;
